export default {
  close: 'Close',
  dataIterator: {
    pageText: '{0}-{1} з {2}',
    noResultsText: 'В результаті пошуку нічого не знайдено',
    loadingText: 'Loading item...',
  },
  dataTable: {
    itemsPerPageText: 'Рядків на сторінці:',
    ariaLabel: {
      sortDescending: ': Sorted descending. Activate to remove sorting.',
      sortAscending: ': Sorted ascending. Activate to sort descending.',
      sortNone: ': Not sorted. Activate to sort ascending.',
    },
    sortBy: 'Sort by',
  },
  dataFooter: {
    itemsPerPageText: 'Елементів на сторінці:',
    itemsPerPageAll: 'Всі',
    nextPage: 'Наступна сторінка',
    prevPage: 'Попередня сторінка',
    firstPage: 'Перша сторінка',
    lastPage: 'Остання сторінка',
  },
  datePicker: {
    itemsSelected: '{0} вибрано',
  },
  noDataText: 'Немає даних для відображення',
  carousel: {
    prev: 'Попередній візуальний',
    next: 'Наступний візуальнийa',
  },
  calendar: {
    moreEvents: 'Ще {0}',
  },
  fileInput: {
    counter: '{0} files',
    counterSize: '{0} files ({1} in total)',
  },
}
